<template>
    <div>
        <div v-if="$acl.check('manager')" class="vx-row">
            <vx-card>
                <h5 style="margin-bottom:9px">Ingresos</h5>
                <span>Reporte basado en las fechas de <strong>cierre de caja</strong>.</span>
                <!-- TABLE ACTION ROW -->
                <div class="flex flex-wrap justify-between items-center">
                    <!-- ITEMS PER PAGE -->
                    <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ sales.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : sales.length }} de {{ sales.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                            <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                            <span>150</span>
                        </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    </div>

                    <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                    <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                        <!-- <from-to-datepickers :from="from" :to="to" /> -->
                        <p style="margin-top:-60px; margin-right:-40px; font-size:10px"> Desde</p>
                        <date-picker :language="languages.es" v-model="from" :first-day-of-week="1" label="Desde" placeholder="Desde" style="margin-right:-10px"></date-picker>
                        <p style="margin-top: -60px; margin-right:-40px; font-size:10px"> Hasta</p>
                        <date-picker :language="languages.es" v-model="to" type="datetime" label="Hasta" placeholder="Hasta" style="margin-right:-10px"></date-picker>
                        <vs-input
                            class="mb-4 md:mb-0 mr-4"
                            v-model="searchQuery"
                            @input="updateSearchQuery"
                            placeholder="Buscar..."/>
                        <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Exportar</vs-button>
                    </div>
                </div>
                <ag-grid-vue
                    ref="agGridTable"
                    :gridOptions="gridOptions"
                    class="ag-theme-material w-100 my-4 ag-grid-table"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="sales"
                    @first-data-rendered="onFirstDataRendered"
                    rowSelection="multiple"
                    colResizeDefault="shift"
                    :animateRows="true"
                    :pagination="true"
                    :paginationPageSize="paginationPageSize"
                    :suppressPaginationPanel="true"
                    :enableRtl="$vs.rtl"
                    :modules="modules">
                </ag-grid-vue>
                <ag-grid-vue style="height: 100px; flex: none;"
                    class="ag-theme-material w-100 ag-grid-table total"
                    :gridOptions="bottomGridOptions"
                    :headerHeight="0"
                    :columnDefs="columnDefs"
                    :rowData="salesFooter"
                    :modules="modules">
                </ag-grid-vue>
                <vs-pagination
                    :total="totalPages"
                    :max="maxPageNumbers"
                    v-model="currentPage" />
            </vx-card>
        </div>
        <div v-if="$acl.check('admin') || $acl.check('superadmin')" class="vx-row">
            <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
                 <vs-tab label="Ventas Tiptap" icon-pack="feather" icon="icon-dollar-sign">
                    <div class="tab-text">
                        <income-sales />
                    </div>
                </vs-tab>
                <vs-tab label="Suscripciones Premium" icon-pack="feather" icon="icon-award">
                    <div class="tab-text">
                        <income-subscriptions />
                    </div>
                </vs-tab>
                <vs-tab label="Servicios Pago Único" icon-pack="feather" icon="icon-tool">
                    <div class="tab-text">
                        <income-services />
                    </div>
                </vs-tab>
                <vs-tab label="Tienda" icon-pack="feather" icon="icon-shopping-cart">
                    <div class="tab-text">
                        <income-marketplace />
                    </div>
                </vs-tab>
                <!-- <vs-tab label="Servicios Pago Recurrente" icon-pack="feather" icon="icon-tool">
                    <div class="tab-text">
                        <income-recurring-services />
                    </div>
                </vs-tab> -->
            </vs-tabs>

        </div>
    </div>
</template>

<script>
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import * as lang from 'vuejs-datepicker/src/locale';
import { AgGridVue } from "@ag-grid-community/vue"
import reportModule from '@/store/report/moduleReport.js'
import DatePicker from "vuejs-datepicker";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import IncomeSales from './IncomeSales.vue'
import IncomeSubscriptions from './IncomeSubscriptions.vue'
import IncomeServices from './IncomeServices.vue'
import IncomeRecurringServices from './IncomeRecurrentServices.vue'
import IncomeMarketplace from './IncomeMarketplace.vue'

export default {
    data() {
        return {
            from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            activeTab: 0,
            languages: lang,
            modules: AllCommunityModules,

            searchQuery: '',
            gridOptions: {
                alignedGrids: [],
                suppressHorizontalScroll: true
            },

            gridOptionsAdmin: {
                alignedGrids: [],
                suppressHorizontalScroll: true
            },


            maxPageNumbers: 6,
            maxPageNumbersSummary: 8,
            gridApiAnnuity: null,


            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            columnDefs: [
                {
                headerName: 'Fecha',
                field: 'sale_date',
                width: 180,
                filter: true,
                comparator: this.myDateComparator,
                sort: 'desc',
                },
                {
                headerName: '# Transacciones',
                field: 'sales_transactions',
                filter: true,
                width: 180,
                },
                {
                headerName: 'Ventas Tiptap',
                field: 'total_tiptap',
                filter: true,
                width: 160,
                valueFormatter: params => this.$options.filters.currencySign(params.data.total_tiptap, '$ '),
                },
                {
                headerName: 'Ventas Tarjeta',
                field: 'total_tarjeta',
                filter: true,
                width: 160,
                valueFormatter: params => this.$options.filters.currencySign(params.data.total_tarjeta, '$ '),
                },
                {
                headerName: 'Ventas Efectivo',
                field: 'total_efectivo',
                filter: true,
                width: 160,
                valueFormatter: params => this.$options.filters.currencySign(params.data.total_efectivo, '$ '),
                },
                {
                headerName: 'Recargas Efectivo',
                field: 'total_recargas',
                filter: true,
                width: 160,
                valueFormatter: params => this.$options.filters.currencySign(params.data.total_recargas, '$ '),
                },
                {
                headerName: 'Total Ingresos',
                field: 'sales_total',
                filter: false,
                width: 175,
                valueFormatter: params => this.$options.filters.currencySign(params.data.sales_total, '$ '),
                cellStyle: {fontWeight: '600'},
                },
            ],

            sales: [],
            salesFooter: [],
            annuity: [],
            annuityFooter: [],
            columnSummary:  [
                {
                headerName: 'Fecha',
                field: 'sale_date',
                width: 180,
                filter: true,
                comparator: this.myDateComparator,
                sort: 'desc',
                },
                {
                headerName: '# Transacciones',
                field: 'sales_transactions',
                filter: true,
                width: 180,
                },
                {
                headerName: 'Ventas Tiptap',
                field: 'total_tiptap',
                filter: true,
                width: 160,
                valueFormatter: params => this.$options.filters.currencySign(params.data.total_tiptap, '$ '),
                },
                {
                headerName: 'Ventas Tarjeta',
                field: 'total_tarjeta',
                filter: true,
                width: 160,
                valueFormatter: params => this.$options.filters.currencySign(params.data.total_tarjeta, '$ '),
                },
                {
                headerName: 'Ventas Efectivo',
                field: 'total_efectivo',
                filter: true,
                width: 160,
                valueFormatter: params => this.$options.filters.currencySign(params.data.total_efectivo, '$ '),
                },
                {
                headerName: 'Recargas Efectivo',
                field: 'total_recargas',
                filter: true,
                width: 160,
                valueFormatter: params => this.$options.filters.currencySign(params.data.total_recargas, '$ '),
                },
                {
                headerName: 'Total Ingresos',
                field: 'sales_total',
                filter: false,
                width: 175,
                valueFormatter: params => this.$options.filters.currencySign(params.data.sales_total, '$ '),
                },
            ],
            summary:[],
            summaryFooter: [],
            bottomGridOptions: {
                alignedGrids: [],
                defaultColDef: {
                    editable: false,
                    sortable: true,
                    resizable: true,
                    filter: true,
                    flex: 1,
                    minWidth: 100
                }
            },
            bottomGridOptionsAdmin: {
                alignedGrids: [],
                defaultColDef: {
                    editable: false,
                    sortable: true,
                    resizable: true,
                    filter: true,
                    flex: 1,
                    minWidth: 100
                }
            },

        }
    },
    components : {
        DatePicker,
        AgGridVue,
        IncomeSales,
        IncomeSubscriptions,
        IncomeServices,
        IncomeRecurringServices,
        IncomeMarketplace
    },

    created() {
        //Modules
        if(!reportModule.isRegistered) {
            this.$store.registerModule('reportModule', reportModule)
            reportModule.isRegistered = true
        }

        if(this.$acl.check('owner')) {
            this.loadTable();
        }

    },
    methods: {
        isDate(val) {
            return val instanceof Date && !isNaN(val.valueOf())
        },
        loadTable() {
            var dates = {from: this.isDate(this.from)?this.from.toISOString().split('T')[0] : '', to:this.isDate(this.to)?this.to.toISOString().split('T')[0] : ''};
            this.$store.dispatch("reportModule/incomesBySales",{id:this.$store.state.AppActiveUser.institution.id, dates:dates})
                .then(response => {
                    let s = JSON.parse(JSON.stringify(response.data));
                    let s_footer = {};

                    if(response.data.length > 0) {

                        s_footer.sale_date = "Total";
                        s_footer.sales_total = 0;
                        s_footer.sales_transactions = 0;
                        s_footer.total_tiptap = 0;
                        s_footer.total_tarjeta = 0;
                        s_footer.total_efectivo = 0;
                        s_footer.total_recargas = 0;

                        s.forEach(element => {
                            element.sale_date = new Date(element.sale_date).toLocaleDateString('es-AR', this.$localeDateOptions)
                            s_footer.sales_total += element.sales_total;
                            s_footer.sales_transactions += element.sales_transactions;
                            s_footer.total_tiptap += element.total_tiptap;
                            s_footer.total_tarjeta += element.total_tarjeta;
                            s_footer.total_efectivo += element.total_efectivo;
                            s_footer.total_recargas += element.total_recargas;
                        });

                    }

                    this.salesFooter = [s_footer];
                    this.sales = s;
                })
                .catch(error => {console.log(error)})
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val);
        },
        updateSearchQueryAnnuity(val) {
            this.gridApiAnnuity.setQuickFilter(val);
        },
        myDateComparator(date1, date2) {
            var date1Number = this.monthToComparableNumber(date1);
            var date2Number = this.monthToComparableNumber(date2);
            if (date1Number === null && date2Number === null) {
                return 0;
            }
            if (date1Number === null) {
                return -1;
            }
            if (date2Number === null) {
                return 1;
            }
            return date1Number - date2Number;
        },
        monthToComparableNumber(date) {
            if (date === undefined || date === null || date.length !== 10) {
                return null;
            }
            var yearNumber = date.substring(6, 10);
            var monthNumber = date.substring(3, 5);
            var dayNumber = date.substring(0, 2);
            var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
            return result;
        },
        setFromTo(f,t) {
            this.from = f;
            this.to = t;
        },
        onFirstDataRendered: function() {
            this.gridColumnApi.autoSizeAllColumns();
        }
    },
    watch: {
        from: function () {
            if(this.$acl.check('manager')) {
                this.loadTable();
            }

            if(this.$acl.check('admin') || this.$acl.check('superadmin')) {
                this.loadAdminTable()
            }

        },
        to: function () {
            if(this.$acl.check('manager')) {
                this.loadTable();
            }

            if(this.$acl.check('admin') || this.$acl.check('superadmin')) {
                this.loadAdminTable()
            }

        },
        '$store.state.windowWidth'(val) {
            if(val <= 576) {
                this.maxPageNumbers = 6;
                this.maxPageNumbersSummary = 8;
            }
        }
    },
    computed: {
        paginationPageSize() {
            if(this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 50
        },
        totalPages() {
            if(this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },

            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
        incomesSeries() {
            return this.incomes.series;
        }
    },
    beforeMount() {
      if(this.$acl.check('manager')) {
        this.gridOptions.alignedGrids.push(this.bottomGridOptions);
        this.bottomGridOptions.alignedGrids.push(this.gridOptions);

        this.gridOptionsAdmin.alignedGrids.push(this.bottomGridOptionsAdmin);
        this.bottomGridOptionsAdmin.alignedGrids.push(this.gridOptionsAdmin);
      }
    },
    mounted() {
      if(this.$acl.check('manager')) {
        this.gridApi = this.gridOptions.api
        this.gridApiAnnuity = this.gridOptionsAdmin.api
        this.gridColumnApi = this.gridOptions.columnApi;
        this.gridColumnApiAnnuity = this.gridOptions.columnApi;

        if(this.$vs.rtl) {
            const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
            header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
        }
      }
    }
}

</script>

<style>

    .ag-cell{
        text-transform: capitalize;
    }
    .ag-grid-table.total .ag-row {
        /* background-color: #7c71f138; */
        font-weight: 700;
    }
    .ag-grid-table.total .ag-header {
        border: none;
    }
    /* .ag-grid-table.total .ag-row-first {
        border-top-width: 1px;
    } */
    .feather-16{
        width: 16px;
        height: 16px;
    }
</style>
